import {HeaderConfig, Row} from 'components/Table/KhulaSupplierTable';
import {ISupplierUserProfile} from 'constants/interfaces';
import React from 'react';
import {Avatar, Box, IconButton, Tooltip} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import LockIcon from '@material-ui/icons/Lock';

export const teamTableHeaders = (showDepotName: boolean): HeaderConfig[] => [
  {
    field: 'image',
    title: '',
    isSortable: false,
    isSearchable: false,
    isRightAligned: true,
  },
  {
    field: 'name',
    title: 'First Name',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'surname',
    title: 'Surname',
    isSortable: true,
    isSearchable: true,
  },
  ...(showDepotName
    ? [
        {
          field: 'depotName',
          title: 'Depot',
          isSortable: true,
          isSearchable: true,
          isRightAligned: false,
        },
      ]
    : []),
  {
    field: 'email',
    title: 'Email',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'phone',
    title: 'Phone',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'actions',
    title: '',
    isSortable: false,
    isSearchable: false,
    isRightAligned: true,
  },
];

export const teamTableRows = (
  team: ISupplierUserProfile[],
  onEdit: (teamMember: ISupplierUserProfile) => any,
  onEditPermissions: (teamMember: ISupplierUserProfile) => any,
  onRemove: (teamMember: ISupplierUserProfile) => any,
): Row[] =>
  team.map((teamMember) => ({
    ...teamMember,
    depotName: getDepotName(teamMember),
    image: <Avatar src={teamMember.pictureUrl} className={'farmer-avatar'} />,
    actions: (
      <TeamMemberRowIcons
        onEdit={() => onEdit(teamMember)}
        onEditPermissions={() => onEditPermissions(teamMember)}
        onRemove={() => onRemove(teamMember)}
      />
    ),
  }));

export function getDepotName(teamMember: ISupplierUserProfile) {
  if (teamMember.isAdmin) return 'Admin';
  // @ts-ignore
  if (teamMember.depots?.length > 1) return 'Multiple Depots';
  return teamMember.depots?.[0]?.name;
}

function TeamMemberRowIcons(props: {
  onEdit: () => any;
  onEditPermissions: () => any;
  onRemove: () => any;
}) {
  return (
    <Box display="flex" flexDirection="row">
      <Tooltip title="Edit Team Member" aria-label="edit team member">
        <IconButton
          aria-label="edit team member"
          size="small"
          onClick={props.onEdit}
        >
          <EditIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Edit Permissions" aria-label="edit permissions">
        <IconButton
          aria-label="edit permissions"
          size="small"
          onClick={props.onEditPermissions}
          style={{marginLeft: 8}}
        >
          <LockIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Remove team member" aria-label="remove team member">
        <IconButton
          aria-label="remove team member"
          size="small"
          onClick={props.onRemove}
          style={{color: 'red', marginLeft: 8}}
        >
          <DeleteOutlineIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
